import { render, staticRenderFns } from "./VideoSession.vue?vue&type=template&id=62bf22c2&scoped=true"
import script from "./VideoSession.vue?vue&type=script&lang=js"
export * from "./VideoSession.vue?vue&type=script&lang=js"
import style0 from "./VideoSession.vue?vue&type=style&index=0&id=62bf22c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bf22c2",
  null
  
)

export default component.exports